/* eslint-disable react/prop-types */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import Image from '@components/global/Image';
import StatusBadge from '@components/global/StatusBadge';

import { ButtonSticky } from '@components/screen/Layout';
import { currency, parseDate } from '@global/helpers';
import Colors from '@global/colors';
import { isWeb, isAndroid, fullWidth } from '@global/screens';
import { showAlert } from '@/store/global';
import { showPopup } from '@/store/modal';
import { logEvent } from '@global/analytics';

const TodoOrder = ({
  containerHeight = 0,
  detailCustomer = {},
  detailData = {},
  detailTodo = {},
  navigation = null,
  localPayload = null,
  onSubmit = () => {},
  onSaveDraft = () => {},
  resetTab = () => {},
  openOrdersForm = () => {},
  openOrdersDetail = () => {},
}) => {
  const dispatch = useDispatch();
  const isLoadingGlobal = useSelector((state) => state.modal.isLoading);
  const [lastPayload, setLastPayload] = useState([]);

  const onSubmitOrder = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const payload = {
        more_info: {
          orders: lastPayload,
        },
      };
      logEvent({
        eventName: 'submit_activity',
        data: {
          activity_id: detailData?._id,
          task_id: detailTodo?._id,
          type: 'orders',
          payload: JSON.stringify(payload),
        },
        dataKey: 'detail',
      });
      await onSubmit({
        targetType: 'orders',
        taskId: detailTodo?._id,
        payload,
      });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      resetTab();
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      let error_message = 'A system error occurred';
      if (error?.response?.data?.message) {
        error_message = error.response.data.message;
      }
      if (!detailTodo?._id) {
        error_message = 'This activity have no todo list activity.';
      }
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: error_message,
          isConfirm: false,
          testID: 'todo-order-validation',
        }),
      );
    }
  };

  const onAddOrder = () => {
    if (navigation && detailCustomer?.is_active) {
      if (detailTodo?._id) {
        openOrdersForm();
      } else {
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Error',
            description: 'Order activity task not found.',
            isConfirm: false,
            testID: 'todo-order-not-found',
          }),
        );
      }
    } else {
      if (!Boolean(detailCustomer?.is_active)) {
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Information',
            description:
              'Customer not active, you can continue to other activity.',
            isConfirm: false,
            testID: 'todo-order-customer-inactive',
          }),
        );
      }
    }
  };

  const goToOrderDetail = (item) => {
    if (navigation) {
      item.activity_id = detailData?._id;
      item.task_id = detailTodo?._id;
      openOrdersDetail(item);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setLastPayload([]);
      const localOrders =
        localPayload?.more_info?.orders || localPayload?.orders || [];
      if (localOrders?.length) {
        setLastPayload(localOrders);
        return;
      }
      if (detailTodo?.orders?.length) {
        setLastPayload(detailTodo.orders);
      }
    }
    return () => {
      mounted = false;
    };
  }, [detailTodo?.orders, localPayload]);

  const saveDraftRef = React.useRef(onSaveDraft);

  useEffect(() => {
    saveDraftRef.current = onSaveDraft;
  }, [onSaveDraft]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const payload = {
        more_info: {
          orders: lastPayload,
        },
      };
      saveDraftRef.current({
        targetType: 'orders',
        taskId: detailTodo?._id,
        payload,
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [lastPayload, detailTodo?._id]);

  return (
    <View
      testID="todo-order-container"
      style={{ width: '100%', height: containerHeight }}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{
          width: '100%',
          padding: 15,
          height: containerHeight - (isAndroid ? 45 : 40),
        }}>
        {lastPayload?.length ? (
          lastPayload.map((item, idx) => (
            <TouchableOpacity
              testID={`todo-order-item-${idx}`}
              activeOpacity={0.8}
              style={{
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: 15,
                marginBottom: 15,
                borderBottomColor: Colors.grey0,
                borderBottomWidth: 1,
                borderRadius: 5,
                backgroundColor: Colors.grey0,
              }}
              onPress={() => goToOrderDetail(item)}
              key={idx}>
              <View
                style={{
                  width: isWeb ? 'calc(100% - 135px)' : fullWidth - 195,
                  paddingRight: 10,
                }}>
                <SociollaText type="medium">{item.reference_code}</SociollaText>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: 10,
                  }}>
                  <Image
                    style={{
                      width: 23,
                      height: 16,
                      marginLeft: -5,
                      marginRight: 5,
                    }}
                    width={23}
                    height={16}
                    svg={true}
                    source={require('@assets/img/icons/menu/calendar.svg')}
                  />
                  <SociollaText style={{ fontSize: 12, color: Colors.grey2 }}>
                    {item.order_date ? parseDate(item.order_date) : '-'}
                  </SociollaText>
                </View>
              </View>
              <View style={{ width: 135 }}>
                <StatusBadge status={item.status} />
                <View style={{ marginTop: 10 }}>
                  <SociollaText type="medium" style={{ color: Colors.blue1 }}>
                    {currency(item.total_amount, true)}
                  </SociollaText>
                </View>
              </View>
            </TouchableOpacity>
          ))
        ) : (
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 100,
            }}>
            <SociollaText>No order found</SociollaText>
          </View>
        )}
        <View style={{ width: '100%', marginBottom: 90 }}>
          <Button
            testID="todo-order-add-btn"
            rounded
            type="default"
            buttonStyle={{ width: '100%' }}
            title={
              <SociollaText
                type="bold"
                style={{ fontSize: 14, letterSpacing: 0.5 }}>
                Add New Order
              </SociollaText>
            }
            onPress={() => onAddOrder()}
          />
        </View>
      </ScrollView>
      <ButtonSticky
        show
        customHost="modal-sticky-button"
        buttons={[
          {
            title: 'Done',
            disabled: lastPayload.length && !isLoadingGlobal ? false : true,
            onPress: () => onSubmitOrder(),
          },
        ]}
      />
    </View>
  );
};

export default React.memo(TodoOrder, (prev, next) => prev == next);
